module.exports = __webpack_public_path__ + "img/title-bg.6c6388c3.png";